import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getPackageList,
  changePackageStatus,
  deletePackage,
} from "../../services/packageService";

import {
  FaSearch,
  FaEdit,
  FaTrash,
  FaToggleOn,
  FaToggleOff,
  FaChevronLeft,
  FaChevronRight,
  FaFilter,
  FaListUl,
} from "react-icons/fa";

import "./PackageListLayer.css";

const PackagePageList = () => {
  const navigate = useNavigate();

  const [packages, setPackages] = useState([]);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("all");

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);

  const loadPackages = async () => {
    const res = await getPackageList({
      page,
      limit,
      search,
      status: status === "all" ? "" : status,
    });

    if (res?.data) {
      setPackages(res.data);
      setTotal(res.total || 0);
    }
  };

  useEffect(() => {
    loadPackages();
  }, [page, search, status, limit]);

  const totalPages = Math.ceil(total / limit) || 1;

  return (
    <div className="page-container">
      <div className="card">

        {/* ===== HEADER ===== */}
        <div className="list-header">
          <h5 className="card-title">Package List</h5>

          <div className="filter d-flex align-center gap-12">

            {/* SEARCH */}
            <div className="search-box">
              <FaSearch />
              <input
                placeholder="Search package..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(1);
                }}
              />
            </div>

            {/* STATUS FILTER */}
            <div className="filter-box">
              <FaFilter />
              <select
                value={status}
                onChange={(e) => {
                  setStatus(e.target.value);
                  setPage(1);
                }}
              >
                <option value="all">All Status</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>

            {/* PAGE SIZE */}
            <div className="filter-box">
              <FaListUl />
              <select
                value={limit}
                onChange={(e) => {
                  setLimit(Number(e.target.value));
                  setPage(1);
                }}
              >
                <option value={10}>10 / page</option>
                <option value={20}>20 / page</option>
                <option value={50}>50 / page</option>
              </select>
            </div>
          </div>
        </div>

        {/* ===== TABLE (DESKTOP) ===== */}
        <div className="table-wrapper desktop-view">
          <table className="package-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Price</th>
                <th>Calls</th>
                <th>Validity</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {packages.length === 0 ? (
                <tr>
                  <td colSpan="6" className="no-data">
                    No packages found
                  </td>
                </tr>
              ) : (
                packages.map((pkg) => (
                  <tr key={pkg.id}>
                    <td>{pkg.name}</td>
                    <td>₹{pkg.price}</td>
                    <td>{pkg.total_calls}</td>
                    <td>{pkg.validity_days} Days</td>

                    {/* STATUS */}
                    <td>
                      <span
                        className={`status-badge ${
                          pkg.status === "active"
                            ? "status-active"
                            : "status-inactive"
                        }`}
                        onClick={() =>
                          changePackageStatus(
                            pkg.id,
                            pkg.status === "active"
                              ? "inactive"
                              : "active"
                          ).then(loadPackages)
                        }
                      >
                        {pkg.status === "active" ? (
                          <>
                            <FaToggleOn /> Active
                          </>
                        ) : (
                          <>
                            <FaToggleOff /> Inactive
                          </>
                        )}
                      </span>
                    </td>

                    {/* ACTION */}
                    <td className="action-col">
                      <button
                        className="icon-btn edit"
                        title="Edit"
                        onClick={() =>
                          navigate(`/add-package/${pkg.id}`)
                        }
                      >
                        <FaEdit />
                      </button>

                      <button
                        className="icon-btn delete"
                        title="Delete"
                        onClick={() => {
                          if (window.confirm("Delete this package?")) {
                            deletePackage(pkg.id).then(loadPackages);
                          }
                        }}
                      >
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* ===== PAGINATION ===== */}
        <div className="pagination">
          <button
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            <FaChevronLeft />
          </button>

          <span>
            Page {page} of {totalPages}
          </span>

          <button
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            <FaChevronRight />
          </button>
        </div>

      </div>
    </div>
  );
};

export default PackagePageList;
